export default "__VITE_ASSET__Bn9$g4sZ__"